import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'ramda';

import ListSkeleton from '../../../../components/Skeletons/ListSkeleton';
import BannerSettingsPresenter from '../../../../presenters/BannerSettingsPresenter';
import {
  LIST_SKELETON_HEIGHT,
  LIST_SKELETON_WIDTH,
} from '../../../../pages/constants';
import { useFetchStatus } from '../../../../utils/fetchStatusUtils';

import BannerSetting from './components/BannerSetting';

const BannerSettingsTable = (props) => {
  const { bannerSettings, loadingStatus, onEditBannerSetting } = props;
  const { isFulfilled } = useFetchStatus(loadingStatus);

  if (!isFulfilled) {
    return (
      <ListSkeleton height={LIST_SKELETON_HEIGHT} width={LIST_SKELETON_WIDTH} />
    );
  }

  const isBannerSettingsEmpty = isEmpty(bannerSettings);

  if (isBannerSettingsEmpty) {
    return <div className="empty-table">No Banner settings</div>;
  }

  return (
    <div>
      <table className="tables">
        <thead>
          <tr>
            <th>Banner type</th>
            <th>Title</th>
            <th>Text</th>
            <th>Font color</th>
            <th>Background color</th>
            <th>Submit button text</th>
            <th>Submit button color</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {bannerSettings.map((bannerSetting) => {
            return (
              <BannerSetting
                key={bannerSetting.id}
                bannerSetting={bannerSetting}
                onEditBannerSetting={onEditBannerSetting}
              />
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default BannerSettingsTable;

BannerSettingsTable.propTypes = {
  bannerSettings: PropTypes.arrayOf(BannerSettingsPresenter.shape()),
  loadingStatus: PropTypes.string.isRequired,
  onEditBannerSetting: PropTypes.func.isRequired,
};

BannerSettingsTable.defaultProps = {
  bannerSettings: [],
};
